import { ApiError } from '../api/api-error';

const GENERIC_MESSAGE = 'Ocurrió un error inesperado. Probá de nuevo.';

/**
 * Only an `ApiError`'s message is safe to show verbatim: it always comes
 * from the server's own `{ error: { code, message } }` envelope (see
 * api/api-error.js), already written for end users. Anything else — a plain
 * `Error`, a `TypeError` from a bug, some other thrown value — could leak
 * internal detail, so pages replace it with a generic Spanish fallback
 * instead of ever rendering it as-is.
 */
export function errorMessageFor(error) {
  if (error instanceof ApiError) return error.message;
  return GENERIC_MESSAGE;
}
